import type { ReactNode } from "react";
import { IconDuplicate } from "@/components/icons";
import { BuilderTabs } from "./BuilderTabs";
import type { BuilderTab } from "./types";

interface FormBuilderTabBarProps {
  active: BuilderTab;
  hooksCount: number;
  submissionsCount?: number;
  showSubmissions: boolean;
  isYandex?: boolean;
  onChange: (tab: BuilderTab) => void;
  showDuplicate?: boolean;
  isDuplicating?: boolean;
  isSaving?: boolean;
  isDeleting?: boolean;
  canManage?: boolean;
  onDuplicate?: () => void;
  trailing?: ReactNode;
}

export function FormBuilderTabBar({
  active,
  hooksCount,
  submissionsCount,
  showSubmissions,
  isYandex,
  onChange,
  showDuplicate = false,
  isDuplicating = false,
  isSaving = false,
  isDeleting = false,
  canManage = true,
  onDuplicate,
  trailing,
}: FormBuilderTabBarProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <BuilderTabs
        active={active}
        hooksCount={hooksCount}
        submissionsCount={submissionsCount}
        showSubmissions={showSubmissions}
        isYandex={isYandex}
        onChange={onChange}
      />
      {trailing}
      {showDuplicate && onDuplicate ? (
        <button
          type="button"
          disabled={isDuplicating || isSaving || isDeleting || !canManage}
          onClick={onDuplicate}
          className={[
            "inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 font-onest text-sm font-medium transition-colors",
            "text-slate-600 hover:bg-white hover:text-slate-900 hover:shadow-sm",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/30",
            "disabled:cursor-not-allowed disabled:opacity-50",
          ].join(" ")}
        >
          <IconDuplicate size={16} />
          {isDuplicating ? "Копирование…" : "Копировать форму"}
        </button>
      ) : null}
    </div>
  );
}
